import React from 'react';

export function useReconciledValue<T>(value: T, reconcileFn: (newValue: T, oldValue: T) => T): T {
  const ref = React.useRef<T>(value);

  ref.current = ref.current === undefined ? value : reconcileFn(value, ref.current);

  return ref.current;
}
